<template>
    <div class="column">
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Issued Date</label>
            </div>
            <div class="field is-expanded remarks">
                <div class="field has-addons">
                    <p class="control">
                        <a class="button is-static">
                            <i class="fas fa-calendar-alt"></i>
                        </a>
                    </p>
                    <p class="control remarks">
                        <input v-model="issued_date" type="date" class="input"/>
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Due Date</label>
            </div>
            <div class="field is-expanded remarks">
                <div class="field has-addons">
                    <p class="control">
                        <a class="button is-static">
                            <i class="fas fa-calendar-alt"></i>
                        </a>
                    </p>
                    <p class="control remarks">
                        <input type="date" v-model="due_date"  class="input"/>
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Balance Due (USD)</label>
            </div>
            <div class="field is-expanded remarks">
                <div class="field has-addons">
                    <p class="control">
                        <a class="button is-static">
                            <i class="fas fa-dollar-sign"></i>
                        </a>
                    </p>
                    <p class="control remarks">
                        <input class="input" v-model="balance_due_usd">
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    export default {
        computed: {
            issued_date: {
                get() {
                    return this.$store.getters.getCustomInvoice.issued_date
                },
                set(value) {
                    this.$store.dispatch('changeCustomInvoiceFieldValue', { field: 'issued_date', value: value })
                }
            },
            due_date: {
                get() {
                    return this.$store.getters.getCustomInvoice.due_date
                },
                set(value) {
                    this.$store.dispatch('changeCustomInvoiceFieldValue', { field: 'due_date', value: value })
                }
            },
            balance_due_usd: {
                get() {
                    return this.$store.getters.getCustomInvoice.balance_due_usd
                },
                set(value) {
                    this.$store.dispatch('changeCustomInvoiceFieldValue', { field: 'balance_due_usd', value: value })
                }
            }
        }

    }
</script>

<style scoped>
    .field-label {
        flex-grow: 0;
    }
    .field-label .label {
        font-size: medium !important;
    }
    .remarks {
        width: 93%;
    }
    .label {
        white-space: nowrap;
        min-width: 100px;
    }
    .is-static {
        min-width: 50px;
    }
</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/Invoices/CustomInvoice/CustomInvoiceDates.vue